import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import './i18n'

import App from './App'

import './index.css'

i18next.init({
  interpolation: { escapeValue: false }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>
)
